import '.z{flex:1;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.bl{gap:8px;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.af{gap:4px;}.ssr-plugin'
import '.hj{color:inherit;}.ssr-plugin'
import React, { Fragment } from 'react'
import { styled, Style } from 'inlines'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { Icon } from '../Icon/index.js'
import { TEXT_VARIANT_STYLES } from '../../tokens/typography.js'
import { Stack } from '../Stack/index.js'
import { Separator } from '../Separator/index.js'

export type LabelDescriptionProps = {
  label: string | string[]
  description?: string
  error?: string
  style?: Style
  children?: React.ReactNode
  disabled?: boolean
}

export const LabelDescription = ({
  label,
  description,
  error,
  style,
  children,
  disabled,
}: LabelDescriptionProps) => {
  const textColor = disabled ? 'neutral20' : 'neutral60'

  return (
    <styled.div className="z h a i bl"
      style={{
        ...style,
      }}
    >
      {label && typeof label === 'string' && (
        <Text variant="subtext-regular" color={textColor}>
          {label}
        </Text>
      )}

      {label && Array.isArray(label) && (
        <Stack style={{ width: '100%' }} justify="start" align="center">
          {label.map((text, index) => {
            return (
              <Fragment key={text}>
                <Text variant="subtext-regular" color={textColor}>
                  {text}
                </Text>
                {index < label.length - 1 && <Separator variant="dot" />}
              </Fragment>
            )
          })}
        </Stack>
      )}
      {children}

      {error && (
        <div className="a b af"
          style={{
            color: colors.red100,
          }}
        >
          <Icon variant="error-filled" color="red100" />
          <styled.span className="hj"
            style={{
              ...TEXT_VARIANT_STYLES['display-medium'],
            }}
          >
            {error}
          </styled.span>
        </div>
      )}
      {description && (
        <Text variant="display-regular" color={textColor}>
          {description}
        </Text>
      )}
    </styled.div>
  )
}
